export const { VITE_SEGMENT_WRITE_KEY, VITE_APP_VERSION, VITE_DOMAIN = '.six-invest.com.au' } = import.meta.env
